export default __webpack_public_path__ + "static/media/FacebookClone1.23148340.png";